import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  mainURL = 'auth/';
  constructor(private http: HttpClient) {}

  loginWithGoogle(user: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'loginWithGoogle', user);
  }

  loginAsLinkedIn(authCode: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'loginWithLinkedIn', authCode);
  }

  loginAsUser(user: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'loginAsUser', user, {
      responseType: 'text' as 'json',
    });
  }

  registerUser(user: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'createUser', user);
  }
 registerCompany(
    requestData: any,
    taxFile: File | null,
    commercialFile: File | null
  ): Observable<any> {
    const formData = new FormData();
 
    // Wrap JSON as Blob — this tells the server the part is application/json
    const requestBlob = new Blob([JSON.stringify(requestData)], {
      type: 'application/json',
    });
    formData.append('request', requestBlob);
 
    if (taxFile) {
      formData.append('taxRegistration', taxFile, taxFile.name);
    }
    if (commercialFile) {
      formData.append('commercialRegistration', commercialFile, commercialFile.name);
    }
 
    return this.http.post(
      environment.apiUrl + this.mainURL + 'createCompany',
      formData
    );
  }

  refreshAccessToken(user: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'refresh-token', user);
  }

  logoutFromGoogle(user: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'logoutuser', user);
  }

  resetPassword(user: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'reset-password', user);
  }

  forgotPassword(email: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'forgot-password', { email });
  }

  verifyOtp(email: any, otp: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'verify-otp', { email, otp });
  }

  changePassword(data: { oldPassword: string; newPassword: string }) {
    const token = localStorage.getItem('accessToken');
    return this.http.post(environment.apiUrl + this.mainURL + 'change-password', data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
}